import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { UtilService } from '../../service/util.service';
import { Constants } from '../../constants/constants';
import { ToastService } from '../../service/toast.service';
import { UserListComponent } from 'src/app/user-list/user-list.component';
import { InviteUserComponent } from 'src/app/invite-user/invite-user.component';
import { ViewUserDetailComponent } from 'src/app/view-user-detail/view-user-detail.component';

@Component({
  selector: 'app-dongle-provider-user-roles',
  templateUrl: './dongle-provider-user-roles.component.html',
  styleUrls: ['./dongle-provider-user-roles.component.scss']
})
export class DongleProviderUserRolesComponent implements OnInit {

  admins: Array<any> = [];
  userRoles: Array<any> = [Constants.ROLE_DONGLE_PROVIDER_ADMIN];

  selectedAdmins: Array<string> = new Array();
  selectedAdminsCount = 0;
  deletedAdminsCount = 0;
  deleteAdminsFailed: Array<string> = new Array();

  isViewUser: boolean = false;

  @ViewChild('userListTemplate') userListTemplate: UserListComponent;
  @ViewChild('inviteUserTemplate', { static: true }) inviteUserTemplate: InviteUserComponent;
  @ViewChild('userDetailTemplate') userDetailTemplate: ViewUserDetailComponent;

  constructor(private apiService: ApiService, public authService: AuthenticationService, public utilService: UtilService, private toast: ToastService) { }

  ngOnInit() {
    this.getAllUsers();
  }

  getAllUsers() {
    this.utilService.showSpinner();
    this.apiService.getDongleProviderUser().then((data) => {
      this.utilService.hideSpinner();
      this.admins = data;
      console.log("admin data ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAllUsers();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  /**
   * Invite User start
   */
  addUsersByRole(requestPayload: any) {
    console.log("Adding user with data : ", requestPayload);
    this.utilService.showSpinner();
    this.apiService.inviteDongleProviderUser(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess("User created successfully");
      this.inviteUserTemplate.resetAddAdminForm();
      document.getElementById("closeInviteAdmin").click();
      this.getAllUsers();
      console.log("add admin response ::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.addUsersByRole(requestPayload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }
  /**
   * Invite User end
   */

  /**
   * User list start
   */

  onDeleteAdmins(admins: Array<string>) {
    this.selectedAdmins = admins;
    console.log("Received the request for delet admins::", this.selectedAdmins);
    if (this.selectedAdmins.length > 0) {
      this.selectedAdminsCount = this.selectedAdmins.length;
      this.selectedAdmins.forEach(userId => {
        this.deleteUser(userId);
      });
    } else {
      this.toast.showWarning("No user selected");
    }
  }

  deleteUser(userId) {
    this.utilService.showSpinner();
    this.apiService.deleteDongleProviderUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.deletedAdminsCount += 1;
      this.resetAdminsDeleted();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deleteUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        this.deleteAdminsFailed.push(userId);
        this.resetAdminsDeleted();
      }
    });
  }

  resetAdminsDeleted() {
    if (this.selectedAdminsCount == (this.deletedAdminsCount + this.deleteAdminsFailed.length)) {

      if (this.deleteAdminsFailed.length == 0) {
        this.toast.showSuccess("Users Deleted successfully");
      } else {
        this.toast.showError("Delete failed for users : " + this.deleteAdminsFailed.length);
      }
      this.getAllUsers();
      this.resetDeleteUser();
      this.userListTemplate.cancelDeleteUser();
    }
  }

  resetDeleteUser() {
    this.selectedAdmins = [];
    this.selectedAdminsCount = 0;
    this.deletedAdminsCount = 0;
    this.deleteAdminsFailed = [];
  }

  onViewUser() {
    this.isViewUser = true;
  }
  /**
   * User list end
   */


  /**
   * User detail start
   */

  closeUserView() {
    this.isViewUser = false;
  }

  activateUser(userId) {
    this.utilService.showSpinner();
    this.apiService.activateDongleProviderUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.userDetailTemplate.onUserActivated();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.activateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  deactivateUser(userId) {
    this.utilService.showSpinner();
    this.apiService.deactivateDongleProviderUser(userId).then((data) => {
      this.utilService.hideSpinner();
      this.userDetailTemplate.onUserDeactivated();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.deactivateUser(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resendInvite(userId) {
    this.utilService.showSpinner();
    this.apiService.resendDongleProviderUserInvite(userId).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data.message);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.resendInvite(userId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onUpdateUserRole(event) {
    console.log("updatee user role data", event);
    this.updateUserRole(event.payload, event.adminId);
  }

  updateUserRole(payload, adminId) {
    this.utilService.showSpinner();
    this.apiService.updateDongleProviderRoles(adminId, payload).then((data) => {
      this.utilService.hideSpinner();
      this.userDetailTemplate.onUserRoleUpdated(payload);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.updateUserRole(payload, adminId);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  resetUserPassword(payload) {
    var user = this.utilService.selectedAccountUser;
    this.utilService.showSpinner();
    this.apiService.resetDongleProviderUserPassword(user.id).then((data) => {
      this.utilService.hideSpinner();
      this.toast.showSuccess(data['message']);
      this.userDetailTemplate.onResetUserPassword();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.resetUserPassword(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }


  /**
   * User detail end
   */


}
